module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAQAQMAAADan0jAAAAAA1BMVEUzMzPK7GI1AAAAC0lEQVQI12MY5gAAAOAAAR8Cr9MAAAAASUVORK5CYII="